export default __webpack_public_path__ + "static/media/Snapinsta_10000000_506076307810239_8571630264001872997_n.06757ec9.mp4";